import Styled, { css } from 'styled-components';

import { BreakPointsMap } from '../../lib/StyledComponents';
import { VALID_BREAKPOINTS } from '../../lib/StyledComponents/StyledComponents';

export interface IConditionalRenderWrapperProps {
  hiddenOnMobile: boolean;
  breakpoint?: VALID_BREAKPOINTS;
}

export const ConditionalRenderWrapper = Styled.div<IConditionalRenderWrapperProps>`
  display: flex;

  ${({ hiddenOnMobile, breakpoint }) => !!hiddenOnMobile ? css`
    @media (max-width: ${
      // tslint:disable-next-line: no-non-null-assertion
      BreakPointsMap[breakpoint!]
    }em) {
      display: none;
    }
  ` : css`
    @media (min-width: ${
      // tslint:disable-next-line: no-non-null-assertion
      BreakPointsMap[breakpoint!]
    }em) {
      display: none;
    }
  `}
`;

ConditionalRenderWrapper.defaultProps = {
  breakpoint: 'mediumLarge'
};

ConditionalRenderWrapper.displayName = 'ConditionalRenderWrapper';
